import React from 'react';

import { formatPhoneNumber } from '@hero/hero-utils/phone';
import { MemberInfo } from '../../../../types';
import { PortalLink as PortalLinkData } from '../../types';
import { EMPTY_VALUE, formatDateOfBirth, formatEnumLabel } from '../../utils/formatters';
import * as Style from '../../style.module.scss';
import EhrCard from '../EhrCard';
import Field from '../Field';
import PortalLink from '../PortalLink';

const formatLocation = (address: MemberInfo['address_info']) => {
    const cityState = [address?.city, address?.state].filter(Boolean).join(', ');

    return [cityState, address?.zip].filter(Boolean).join(' ') || EMPTY_VALUE;
};

type Props = {
    memberInfo: MemberInfo;
    portalLink: PortalLinkData | null;
    isPortalLinkLoading: boolean;
};

const Reference: React.FC<Props> = ({ memberInfo, portalLink, isPortalLinkLoading }) => (
    <EhrCard title="Reference">
        <div className={Style.fieldGrid}>
            <Field
                label="Date of birth"
                value={formatDateOfBirth(memberInfo.contact_info.date_of_birth)}
            />
            <Field label="Sex" value={formatEnumLabel(memberInfo.gender)} />
            <Field
                label="Phone"
                value={
                    memberInfo.contact_info.phone_number
                        ? formatPhoneNumber(memberInfo.contact_info.phone_number, 'national')
                        : EMPTY_VALUE
                }
            />
            <Field label="Email" value={memberInfo.contact_info.email || EMPTY_VALUE} />
            <Field label="Location" value={formatLocation(memberInfo.address_info)} />
            <PortalLink
                memberId={memberInfo.member_id}
                portalLink={portalLink}
                isLoading={isPortalLinkLoading}
            />
        </div>
    </EhrCard>
);

export default Reference;
